import React, { FC } from "react";
import {
  FormattedMessage,
  FormattedMessageProps,
} from "@I18n/Components/FormattedMessage/FormattedMessage";
import { MessageDescriptor } from "react-intl";
import useMediaQuery from "@UI/hooks/useMediaQuery";

interface Props {
  desktop: MessageDescriptor;
  mobile: MessageDescriptor;
  values?: FormattedMessageProps["values"];
}

export const ResponsiveFormattedMessage: FC<Props> = ({
  mobile,
  desktop,
  values,
}) => {
  const { isMobile } = useMediaQuery();
  const message = isMobile ? mobile : desktop;
  return <FormattedMessage {...message} values={values} />;
};
